import React from 'react';
import Header, { HeaderType } from '@/components/Layout/Header/Header';
import Footer from '@/components/Layout/Footer/Footer';
import { ContentLayout } from '@/components/Layout';
import { useTermsCondition } from '@/api/termsCondition';
import TermsLoader from '@/components/Elements/Loader/TermsLoader';
import i18next from 'i18next';
import prf from '@/assets/prf.png';
import banner from '@/assets/main-banner.png';
export const TermCondition = () => {
  // const data = termsCondition();
  const { data, isLoading } = useTermsCondition();

  const articleContent = data?.data.page_content;

  return (
    <ContentLayout title={i18next.t(`Privacy & Policy`)}>
      <div>
        <Header type={HeaderType.LANDING} />

        <div
          className="container profileContainer prf-common relative "
          style={{ backgroundImage: 'url(' + banner + ')' }}
        >
          <div className="row p-3 profl-lft align-items-center relative">
            <div className="col-12 col-md-8 ">
              <h4 className="mb-1 text-white f-40">Terms & Conditions</h4>

              <p className="mb-1 text-white">
                Your profile on REEIPO . The more information you add here, the more we can
                customize REEIPO for you.
              </p>
            </div>
            <div className="col-12 col-md-4">
              <div className="side-image">
                <img src={prf} className="side-image" alt="" />
              </div>
            </div>
          </div>
        </div>
        {/* <section className="promo-about-pg py-5">
          <div className="container">
            <div className="about-content text-center">
              <h2 className="f-30 semibold">{i18next.t(`Terms & Conditions for Reeipo.`)}</h2>
            </div>
          </div>
        </section> */}
        {isLoading ? (
          <TermsLoader />
        ) : (
          <section className="about-content-first  about-privacy  pt-5 pb-5">
            <div className="container">
              <div className="about-us-box">
                {/* <h2 className="f-30 semibold mb-2">{i18next.t(`Terms & Conditions`)}</h2> */}
                <div className="terms-box text-dark ">
                  <div dangerouslySetInnerHTML={{ __html: articleContent }} />
                </div>
              </div>
            </div>
          </section>
        )}
        <Footer />
      </div>
    </ContentLayout>
  );
};
